import type { ReactNode } from "react";
import { Badge } from "@/components/base/badges/badges";

export function SectionHeading({ title, count, action }: { title: string; count: number; action?: ReactNode }) {
  return (
    <div className="flex h-9 shrink-0 flex-row items-center justify-between">
      <div className="flex items-center gap-2">
        <span className="text-lg font-medium text-secondary">{title}</span>
        <Badge type="pill-color" size="sm" color="brand">
          {count}
        </Badge>
      </div>
      {action}
    </div>
  );
}
